<script setup lang="ts">
import { useCreateUserDelegation } from "~/modules/relation/delegation/composables/useCreateUserDelegation";
import type { UserDelegation } from "~/modules/relation/delegation/models/UserDelegation.interface";
import type { RelationEntity } from "~/modules/relation/models/RelationEntity.interface";
import UserDelegationForm from "~/modules/user/components/UserDelegationForm.vue";

const props = defineProps<{
  businessUnitCode?: number;
  organizationCode?: number;
  userLogin?: string;
  receivedDelegations?: RelationEntity[] | null;
  userDelegations?: UserDelegation[] | null;
}>();

const { canCreateUserDelegation } = useCreateUserDelegation({
  organizationCode: props.organizationCode,
  businessUnitCode: props.businessUnitCode,
});

const showDelegationForm = ref(false);

function addDelegation() {
  showDelegationForm.value = true;
}
</script>

<template>
  <div>
    <h6 class="mb-4 font-bold">
      {{ $t("user.form.tabs.delegations") }}
    </h6>
    <add-bar
      v-if="
        canCreateUserDelegation() &&
        receivedDelegations &&
        receivedDelegations.length > 0
      "
      :text="$t(`administration.relations.delegations.add.button`)"
      button-type="tertiary"
      class="!text-gray-400 !bg-transparent !border-gray-400 mb-4"
      @click="addDelegation"
    />
    <div class="flex flex-col gap-2">
      <user-delegation-form
        v-if="showDelegationForm"
        :organization-code="organizationCode"
        :business-unit-code="businessUnitCode"
        :user-login="userLogin"
        :received-delegations="receivedDelegations"
        @cancel="showDelegationForm = false"
      />

      <user-delegation-list
        :organization-code="organizationCode"
        :business-unit-code="businessUnitCode"
        :user-login="userLogin"
        :received-delegations="receivedDelegations"
        :user-delegations="userDelegations"
      />
    </div>
  </div>
</template>
